module.exports = __webpack_public_path__ + "static/ajao-e52bdaf429c44e74c3dd8585dccb66e1.png";